@if (!intialProcessing) {
    <nz-table
        [@fadeAnimation]
        class="adspt-reusable adspt-table"
        [ngClass]="{ bordered: border, 'no-bordered': !border }"
        #adsptTable
        [nzBordered]="border"
        [nzWidthConfig]="columnsWidths"
        [nzLoading]="loading"
        nzSize="middle"
        [nzTitle]="title ? titleTmpl : null"
        [nzFooter]="footer ? footerTmpl : null"
        [nzData]="data"
        nzFrontPagination="false"
        [nzTotal]="total"
        [nzPageIndex]="pageIndex"
        [nzPageSize]="pageSize"
        [nzShowPagination]="total > 9"
        [nzShowSizeChanger]="total > 9"
        [nzPageSizeOptions]="[10, 25, 50, 100, 500]"
        [nzScroll]="hasInnerScroll ? scroll : null"
        [nzNoResult]="noResultTemplate || ('common.no-data' | translate)"
        [nzTableLayout]="tableLayout"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
    >
        <thead (nzSortOrderChange)="onSort($event)">
            <tr>
                @if (expandable) {
                    <th>
                        <span style="visibility: hidden">*****</span>
                    </th>
                }
                @if (selection) {
                    <th
                        nzShowCheckbox
                        [(nzChecked)]="isAllDisplayDataChecked"
                        [nzIndeterminate]="isIndeterminate"
                        (nzCheckedChange)="onAllChecked($event)"
                    ></th>
                }
                @for (column of config.columns; track column) {
                    <th
                        [nzAlign]="column.align || 'left'"
                        nz-tooltip
                        [nzTooltipTitle]="column.tooltip"
                        nzTooltipPlacement="top"
                        [nzShowSort]="column.sortable"
                        [nzColumnKey]="column.key"
                        [nzSortPriority]="!config.singleSort ? sortOrder[column.key] : false"
                        [nzSortFn]="true"
                        [nzSortOrder]="getColumnSort(column.key)"
                        [nzShowFilter]="column.filterable"
                        [nzFilters]="column.filterOptions | async"
                        [adsptHeap]="heapFilterSelectors[column.key]"
                        [heapDisabled]="!heapFilterSelectors[column.key]"
                        (nzFilterChange)="onFilter($event, column.key)"
                        [nzCustomFilter]="headerTemplates[column.key] || null"
                    >
                        <ng-container
                            *ngTemplateOutlet="
                                headerTemplates[column.key] || defaultHeaderTmpl;
                                context: { $implicit: column }
                            "
                        ></ng-container>
                        @if (total > 1 && !config.singleSort && getColumnSort(column.key)) {
                            <span class="sort-no">{{ sortOrder[column.key] }}</span>
                        }
                    </th>
                }
                @if (hasActions) {
                    <th nzAlign="center">
                        <ng-container
                            *ngTemplateOutlet="
                                headerTemplates.actions || defaultActionHeaderTmpl;
                                context: { $implicit: column }
                            "
                        ></ng-container>
                    </th>
                }
            </tr>
        </thead>
        <tbody>
            @for (data of adsptTable.data; track data) {
                <tr>
                    @if (expandable) {
                        <td
                            nzShowExpand
                            [(nzExpand)]="data.expanded"
                            (nzExpandChange)="onExpandChanged(data)"
                            nzAlign="center"
                        ></td>
                    }
                    @if (selection) {
                        <td
                            nzShowCheckbox
                            [(nzChecked)]="data.checked"
                            (nzCheckedChange)="onRowChecked()"
                            nzAlign="center"
                        ></td>
                    }
                    @for (column of config.columns; track column) {
                        <td [nzAlign]="column.align || 'left'">
                            @if (!columnTemplates[column.key]) {
                                {{ data[column.key] }}
                            }
                            @if (columnTemplates[column.key]) {
                                <ng-container
                                    [ngTemplateOutlet]="columnTemplates[column.key]"
                                    [ngTemplateOutletContext]="{ $implicit: data }"
                                >
                                </ng-container>
                            }
                        </td>
                    }
                    @if (hasActions) {
                        <td align="center">
                            <ng-container
                                [ngTemplateOutlet]="actionsTemplate"
                                [ngTemplateOutletContext]="{ $implicit: data, items: adsptTable }"
                            >
                            </ng-container>
                        </td>
                    }
                </tr>
                <tr [nzExpand]="data.expanded && expandable">
                    <td></td>
                    <td [attr.colspan]="expandRowColspan">
                        <ng-container
                            [ngTemplateOutlet]="expandTemplate"
                            [ngTemplateOutletContext]="{ $implicit: data }"
                        >
                        </ng-container>
                    </td>
                </tr>
            }
        </tbody>
    </nz-table>
}
@if (intialProcessing) {
    <div class="main-loader">
        <nz-spin nzSimple></nz-spin>
    </div>
}

<ng-template let-column #defaultHeaderTmpl>
    {{ column.displayName }}
</ng-template>

<ng-template let-column #defaultActionHeaderTmpl>
    {{ 'common.actions' | translate }}
</ng-template>

<ng-template #titleTmpl>
    <div class="title-wrapper">
        @if (config.title) {
            @if ((config.titleHeader || 'h2') === 'h2') {
                <h2>{{ config.title }}</h2>
            }
            @if (config.titleHeader || 'h3') {
                <h3>{{ config.title }}</h3>
            }
        }

        <div class="refiner search">
            <nz-input-group [nzPrefix]="prefixIconSearch" [nzSuffix]="suffixTemplate">
                <input
                    [adsptHeap]="heapSearchSelector"
                    type="text"
                    nz-input
                    [placeholder]="config.search?.placeholder || ('global-filter.search-placeholder' | translate)"
                    [formControl]="query"
                />
            </nz-input-group>
            <ng-template #prefixIconSearch>
                <adspt-icon name="zoom" class="search" />
            </ng-template>
            <ng-template #suffixTemplate>
                @if (!!query.value) {
                    <adspt-icon name="close-circle" (click)="query.setValue('')" />
                }
            </ng-template>
        </div>
    </div>
</ng-template>

<ng-template #footerTmpl>
    <p class="subtitle">
        @if (total) {
            <span>{{ 'common.total' | translate }}: {{ total }}</span>
        }
    </p>
</ng-template>
